import values from "../values";

import { Layout } from "../components";
import { NotFound, OtherScreen } from "../screen";
import { Navigate, Route, Routes } from "react-router-dom";

import SuperAgentContainer from "../screen/SuperAgentScreen";
// import DashboardContainer from "../screen/DashboardScreen/container";
import ServiceContainer from "../screen/ServiceScreen/Container/SuperAgent.Container";
// import CompanyContainer from "../screen/CompanyScreen/Container/Administrator.container";
import SchoolContainer from "../screen/SchoolScreen/Container";
import DriverContainer from "../screen/DriverScreen/Container/Administrator.container";
import ParentContainer from "../screen/ParentScreen/Container/Administrator.container";
import DashboardContainer from "../screen/DashboardScreen/container";
// import AbsentContainer from "../screen/AbsentScreen/Container";
// import HistoryContainer from "../screen/LogScreen/Container";
// import FinanCialScreen from "../screen/FinancialScreen/";
// import GovernmentShipContainer from "../screen/GovernmentShipScreen/Container";
// import MunicipalityCityContainer from "../screen/MunicipalityScreen/Container";

const ProvinceEducationRoute = () => {
  return (
    <Layout topMenuItems={values.topMenuItems.TOP_MENU_ROLE_PROVINCE_EDUCATION}>
      <Routes>
        <Route
          path="/"
          element={<Navigate to={"panel/province-education"} />}
        />
        <Route path="/super-agent/*" element={<SuperAgentContainer />} />
        {/* <Route path="/company/*" element={<CompanyContainer />} /> */}
        <Route path="/service/*" element={<ServiceContainer />} />
        <Route path="/parents/*" element={<ParentContainer />} />
        <Route path="/school/*" element={<SchoolContainer />} />
        {/* <Route path="/driver/*" element={<DriverContainer />} /> */}
        <Route path="/dashboard/*" element={<DashboardContainer />} />
        {/* <Route path="/absent/*" element={<AbsentContainer />} /> */}
        {/* <Route path="/history/*" element={<HistoryContainer />} /> */}
        {/* <Route path="/financial/*" element={<FinanCialScreen />} /> */}
        {/* <Route path="/municipality/*" element={<MunicipalityCityContainer />} /> */}
        {/* <Route
          path="/government-ship/*"
          element={<GovernmentShipContainer />}
        /> */}
        {/* <Route path="/other/*" element={<OtherScreen />} /> */}
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
};

export default ProvinceEducationRoute;
